import { useTranslation } from 'react-i18next';
import { CardWrapper } from './PDFViewerCard.styles';
import DocumentViewer from '../../DocumentViewer';

interface Props {
    url: string;
}

const PDFViewerCard = (props: Props) => {
    const { url } = props;
    const { t } = useTranslation();

    return (
        <CardWrapper>
            <DocumentViewer
                url={url}
                enableFullscreen
                fullscreenTitle={t('jobApplicationPage.candidateResume')}
            />
        </CardWrapper>
    );
};

export default PDFViewerCard;
